import React from 'react';
import cx from 'classnames';

import styles from './style.module.scss';

interface Props {
  children: any;
  className?: string;
  dashedBorder?: boolean;
  style?: any;
}

export default (props: Props) => {
  return (
    <div
      className={cx('d-flex flex-column', styles.container, props.className)}
      style={{ position: 'relative', ...(props.style || {}) }}
    >
      {
        props.dashedBorder && (
          <>
            <div
              className={cx('hidden-xs', styles.dashedBorderVertical)}
              style={{ position: 'absolute', height: '100%', left: 0, width: 1, zIndex: 20 }}
            />

            <div
              className={cx('hidden-xs', styles.dashedBorderVertical)}
              style={{ position: 'absolute', height: '100%', right: 0, width: 1, zIndex: 20 }}
            />
          </>
        )
      }

      {props.children}
    </div>
  );
};
